<template>
    <div>
        <div>
            <InertiaLink
                :href="route('admin.bookmarks.index')"
                target="_blank"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path d="M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z"></path>
                </svg>
                {{ $tc('messages.bookmarks', 2) }}
            </InertiaLink>
        </div>

        <SidebarDropdown>
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        fill-rule="evenodd"
                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
                {{ $tc('messages.dates', 2) }}
            </template>
            <template v-slot:items>
                <InertiaLink
                    :href="route('admin.holidays.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.holidays', 2) }}
                </InertiaLink>
                <InertiaLink
                    :href="route('admin.school_years.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.school_year') }}
                </InertiaLink>
            </template>
        </SidebarDropdown>

        <div>
            <InertiaLink
                :href="route('admin.groups.index')"
                target="_blank"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
                    ></path>
                </svg>
                {{ $tc('messages.groups', 2) }}
            </InertiaLink>
        </div>

        <div v-section:school_management>
            <InertiaLink
                :href="route('admin.qualitative_reports.categories.index')"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <svg
                    :class="version.iconClasses"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150 icon icon-tabler icon-tabler-report-analytics"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"></path>
                    <rect x="9" y="3" width="6" height="4" rx="2"></rect>
                    <path d="M9 17v-5"></path>
                    <path d="M12 17v-1"></path>
                    <path d="M15 17v-3"></path>
                </svg>
                {{ $tc('messages.qualitative_reports', 2) }}
            </InertiaLink>
        </div>

        <SidebarDropdown>
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
                    ></path>
                </svg>
                {{ $tc('messages.people', 2) }}
            </template>
            <template v-slot:items>
                <InertiaLink
                    :href="route('admin.teachers.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.teachers', 2) }}
                </InertiaLink>
                <InertiaLink
                    :href="route('admin.students.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.students', 2) }}
                </InertiaLink>
                <InertiaLink
                    :href="route('admin.relatives.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:school_management
                >
                    {{ $tc('messages.relatives', 2) }}
                </InertiaLink>
                <InertiaLink
                    :href="route('admin.staff.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:school_management
                >
                    {{ $t('messages.staff') }}
                </InertiaLink>
            </template>
        </SidebarDropdown>

        <SidebarDropdown v-section:school_management>
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
                    ></path>
                </svg>
                {{ $tc('messages.payments', 2) }}
            </template>
            <template v-slot:items>
                <InertiaLink
                    :href="route('admin.payments.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.payments_quotas', 2) }}
                </InertiaLink>
                <InertiaLink
                    :href="route('admin.scholarships.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.scholarships', 2) }}
                </InertiaLink>
            </template>
        </SidebarDropdown>

        <SidebarDropdown>
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"
                    ></path>
                </svg>
                {{ $t('messages.progress_evaluation') }}
            </template>
            <template v-slot:items>
                <InertiaLink
                    :href="route('admin.progress_evaluation_categories.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.categories', 2) }}
                </InertiaLink>
            </template>
        </SidebarDropdown>

        <SidebarDropdown>
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"
                    ></path>
                </svg>
                {{ $t('messages.syllabus') }}
            </template>
            <template v-slot:items>
                <InertiaLink
                    :href="route('admin.categories.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.edit') }}
                </InertiaLink>
            </template>
        </SidebarDropdown>

        <SidebarDropdown v-section:school_management>
            <template v-slot:button>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                    <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
                    <line x1="9" y1="17" x2="9" y2="12"></line>
                    <line x1="12" y1="17" x2="12" y2="16"></line>
                    <line x1="15" y1="17" x2="15" y2="14"></line>
                </svg>
                {{ $t('messages.student_file') }}
            </template>
            <template v-slot:items>
                <InertiaLink
                    :href="route('admin.student_file_tags.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.student_file_tags', 2) }}
                </InertiaLink>
                <InertiaLink
                    :href="route('admin.student_file_custom_sections.sections.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.custom_school_annotations') }}
                </InertiaLink>
            </template>
        </SidebarDropdown>

        <SidebarDropdown v-section:school_management>
            <template v-slot:button>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                    <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    <line x1="12" y1="11" x2="12" y2="14"></line>
                </svg>
                {{ $tc('messages.fouls', 2) }}
            </template>
            <template v-slot:items>
                <InertiaLink
                    :href="route('admin.foul_configs.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.automatic_fouls', 2) }}
                </InertiaLink>
            </template>
        </SidebarDropdown>
    </div>
</template>
<script setup>
import SidebarDropdown from '@/components/SidebarDropdown.vue';
import { useAppSections } from '@/composables/useAppSections.js';

const props = defineProps({
    sections: {
        type: Array,
        required: false,
        default: () => [],
    },
});

const { vSection } = useAppSections(props.sections);

const version = {
    iconClasses: 'mr-3',
    anchorClasses: 'text-sm leading-5',
};
</script>
